import axios from "axios";
import { toast } from "react-toast";
import { config } from "../../config";
import { setLoader } from "../../Store/reducers/LoaderReducer";
import { store } from "../../Store/Store";

const axiosApi = axios.create();

/****** Intercepts Requests *******/
axiosApi.interceptors.request.use(
  (req) => {
    const exemptedRequest = [`${config.apiUrl}/contact-us/count`, `${config.apiUrl}/misc/check-email-existance`];
    if (!exemptedRequest.includes(req.url) && req.url.indexOf(`${config.apiUrl}/misc/league/revenue/`) === -1) {
      store.dispatch(setLoader(true));
    }

    req.headers.Authorization = `Bearer ${localStorage.getItem('token') ? localStorage.getItem('token') : ''}`;
    return req;
  }
);

/****** Intercepts Response ********/
axiosApi.interceptors.response.use(function (response) {
  setTimeout(() => {
    if (response?.config?.url && response?.config?.url.indexOf(`${config.apiUrl}/misc/league/revenue/`) === -1) {
      store.dispatch(setLoader(false))
    }
  }, 100);
  if (response && response.data && response.data.status === 'success') {
    if (!response.config.url.includes('teams/check/scheduling')) {
      if (response.data.message) {
        toast.hideAll();
        toast.success(response.data.message);
      }
    }
  }
  return response;
}, function (error) {
  store.dispatch(setLoader(false));
  if (error && error.response && error.response.status) {
    if (error.response.status === 401) {
      toast.hideAll();
      toast.error('Unauthorized');
      localStorage.removeItem('token')
      window.location.href = '/login';
    } else {
      if (error.response.data && error.response.data.message) {
        toast.hideAll();
        toast.error(error.response.data.message);
      } else {
        toast.hideAll();
        toast.error(error.response.data.message);
      }
    }
  }

  // do what you want to do when error happens
  return Promise.reject(error);
});

export default axiosApi;
